import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'NoResults',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", width: "64", height: "64", viewBox: "0 0 64 64" }
      }, ctx.data]),
      [h("path", {
        attrs: { fill: "currentColor", d: "M63.22 59.45l-15.9-15.9c9.32-11.4 7.64-28.21-3.76-37.53S15.35-1.61 6.02 9.79-1.61 38 9.79 47.32c9.82 8.03 23.95 8.03 33.77 0l15.9 15.9a2.668 2.668 0 0 0 3.77 0 2.677 2.677 0 0 0-.01-3.77zm-36.5-11.43c-11.77 0-21.3-9.54-21.3-21.31s9.54-21.3 21.31-21.3 21.3 9.54 21.3 21.3c-.02 11.77-9.55 21.3-21.31 21.31zM16.07 21.39c0-1.47 1.19-2.66 2.66-2.66 1.47 0 2.66 1.19 2.66 2.66 0 1.47-1.19 2.66-2.66 2.66-1.47 0-2.66-1.19-2.66-2.66zm15.97 0c0-1.47 1.19-2.66 2.66-2.66 1.47 0 2.66 1.19 2.66 2.66a2.659 2.659 0 1 1-5.32 0zm6.3 14.63c.75 1.27.32 2.9-.94 3.65s-2.9.32-3.65-.94a8.168 8.168 0 0 0-11.17-2.89c-1.19.7-2.18 1.69-2.89 2.89a2.654 2.654 0 0 1-3.66.89 2.673 2.673 0 0 1-.93-3.6c3.78-6.41 12.05-8.55 18.46-4.77 1.97 1.16 3.61 2.8 4.78 4.77z" }
      })]
    );
  }
};